import { resolveNoContent, resolveWithBody } from "./Utils/utils";

export default {
    init(promiseRequest) {
        return {
            getSourceEvents() {
                return promiseRequest({
                    url: `/api/notifications/events`,
                    method: "get",
                    json: true,
                }).then(resolveWithBody());
            },
            calculateReceiversForEvents(eventIds) {
                return promiseRequest({
                    url: `/api/notifications/events`,
                    method: "post",
                    json: {
                        eventIds: eventIds,
                    },
                }).then(resolveWithBody());
            },
            getPricingSummary() {
                return promiseRequest({
                    url: `/api/notifications/pricings`,
                    method: "get",
                    json: true,
                }).then(resolveWithBody());
            },
            getCountriesSummary(eventIds) {
                if (!eventIds?.length) {
                    return Promise.resolve([]);
                }

                return promiseRequest({
                    url: `/api/notifications/countries-summary?eventIds=${eventIds.join(",")}`,
                    method: "get",
                    json: true,
                }).then(resolveWithBody());
            },
            getSearchSummary(eventIds, countryCodes, paymentStatus) {
                const params = {
                    eventIds: eventIds.join(","),
                    countries: countryCodes.join(","),
                    paymentStatus: paymentStatus,
                };

                const queryString = new URLSearchParams(params).toString();

                return promiseRequest({
                    url: `/api/notifications/search-summary?${queryString}`,
                }).then(resolveWithBody());
            },
            getSearchResults(eventIds, countryCodes, paymentStatus, { limit, cursor, direction }) {
                const params = {
                    eventIds: eventIds.join(","),
                    countries: countryCodes.join(","),
                    paymentStatus: paymentStatus,
                    limit: limit,
                    cursor: cursor,
                    direction: direction,
                };

                const queryString = new URLSearchParams(params).toString();

                return promiseRequest({
                    url: `/api/notifications/search-results?${queryString}`,
                }).then(resolveWithBody());
            },
            calculateCost(type, eventIds, countryCodes, paymentStatus) {
                const params = {
                    type: type,
                    eventIds: eventIds.join(","),
                    countries: countryCodes.join(","),
                    paymentStatus: paymentStatus,
                };

                const queryString = new URLSearchParams(params).toString();

                return promiseRequest({
                    url: `/api/notifications/costs?${queryString}`,
                }).then(resolveWithBody());
            },
            createNotificationOrder(notificationSearchCriteria, notificationType, startAt, content, replyTo) {
                return promiseRequest({
                    url: "/api/notification-orders",
                    method: "post",
                    json: {
                        notificationReceiverSearchCriteria: {
                            eventIds: notificationSearchCriteria.eventIds,
                            countries: notificationSearchCriteria.countries,
                            paymentStatus: notificationSearchCriteria.paymentStatus,
                        },
                        notificationType: notificationType,
                        startAt: startAt,
                        content: content,
                        replyTo: replyTo,
                    },
                }).then(resolveNoContent());
            },
            getNotificationOrdersListing() {
                return promiseRequest({
                    url: `/api/notification-orders`,
                    method: "get",
                    json: true,
                }).then(resolveWithBody());
            },
            cancelNotificationOrder(id) {
                return promiseRequest({
                    url: `/api/notification-orders/${id}`,
                    method: "delete",
                    json: true,
                }).then(resolveNoContent());
            },
            getInboxNotificationsForUser(userId) {
                return promiseRequest({
                    url: `/api/users/${userId}/inbox/notifications`,
                    method: "get",
                    json: true,
                }).then(resolveWithBody());
            },
            markNotificationsAsRead(userId, ids) {
                return promiseRequest({
                    url: `/api/users/${userId}/inbox/notifications`,
                    method: "put",
                    json: { ids: ids },
                }).then(resolveNoContent());
            },
            deleteNotification(userId, id) {
                return promiseRequest({
                    url: `/api/users/${userId}/inbox/notifications/${id}`,
                    method: "delete",
                    json: true,
                }).then(resolveNoContent());
            },
        };
    },
};
